import React from "react";
import { useLocation } from "react-router-dom";
import SiteNav from "./SiteNav";
import SiteFooter from "./SiteFooter";
import MotionPage from "./MotionPage";

const MarketingLayout = ({ children }) => {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  return (
    <div className={`sv-page${isHome ? " sv-page--home" : ""}`}>
      <SiteNav />
      <MotionPage className="sv-page__content">
        <main>{children}</main>
      </MotionPage>
      <SiteFooter />
    </div>
  );
};

export default MarketingLayout;
